import { render, staticRenderFns } from "./holidayActMaleRank.vue?vue&type=template&id=c63da0bc&scoped=true"
import script from "./holidayActMaleRank.vue?vue&type=script&lang=js"
export * from "./holidayActMaleRank.vue?vue&type=script&lang=js"
import style0 from "./holidayActMaleRank.vue?vue&type=style&index=0&id=c63da0bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63da0bc",
  null
  
)

export default component.exports